import type { ReactElement } from 'react';
import type { FooterKeyLink } from '@amplience/content-types/typings/c-footer-key-links';
import { ImagePartial } from '../../../partials/image';
import { getLocalizedValue } from '../../../utils/transformers';
import { ImageContainer, KeyLinkContainerWrapper, KeyLinkDescription, KeyLinkTitle } from './FooterKeyLinks.styles';

interface KeyLinkContainerProps {
  readonly keyLink: FooterKeyLink;
}

export function KeyLinkContainer({ keyLink }: KeyLinkContainerProps): ReactElement {
  return (
    <KeyLinkContainerWrapper>
      <ImageContainer className="keylink-icon" aria-hidden>
        <ImagePartial
          altText={keyLink.icon?.altText}
          src={keyLink.icon?.image?.name ?? ''}
          assetType={keyLink.icon?.assetType}
          height={16}
          width={16}
          objectFit="contain"
          defaultHost={keyLink.icon?.image?.defaultHost}
          useOriginalSize={keyLink.icon?.useOriginalSize}
        />
      </ImageContainer>
      <div>
        <KeyLinkTitle>{getLocalizedValue(keyLink.title)}</KeyLinkTitle>
        <KeyLinkDescription>{getLocalizedValue(keyLink.description)}</KeyLinkDescription>
      </div>
    </KeyLinkContainerWrapper>
  );
}

export default KeyLinkContainer;
